import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FileTypeEnum} from '@core/modules/rest/file/file-type.enum';

@Component({
    selector: 'app-blank-dialog',
    templateUrl: './blank-dialog.component.html',
    styleUrls: ['./blank-dialog.component.scss']
})
export class BlankDialogComponent {
    multimediaPath: string;
    multimediaType: FileTypeEnum;

    fileTypeImage = FileTypeEnum.IMAGE;
    fileTypeVideo = FileTypeEnum.VIDEO;

    constructor(private dialog: MatDialogRef<BlankDialogComponent>,
                @Inject(MAT_DIALOG_DATA) data: { path: string, type: FileTypeEnum }) {
        this.multimediaPath = data.path;
        this.multimediaType = data.type;
    }

}
